export const muiInputBaseOverrides = {
  root: {
    lineHeight: "initial",
  },
};
